<h1 class="page-title">
  <a routerLink="/dashboard" [queryParams]="{ uid: currentUser?.id }" class="nav-back"><i class="icon icon-arrow-left-9"></i></a> Customer
  Management
</h1>

<div class="container">
  <ul class="d-flex flex-nowrap tab-bar">
    <li [ngClass]="actTab === 'tab1' ? 'active-tab' : ''" (click)="activeTab('tab1')">
      <span>Manage Product Signup</span>
    </li>
    <li [ngClass]="actTab === 'verificationCodes' ? 'active-tab' : ''" (click)="activeTab('verificationCodes')">
      <span>Verification Codes</span>
    </li>
    <!-- <li [ngClass]="actTab === 'tab2' ? 'active-tab' : ''" (click)="activeTab('tab2')" *ngIf="isSuperAdmin">
      <span>Edit Product Signup</span>
    </li> -->
    <!-- <li [ngClass]="actTab === 'tab3' ? 'active-tab' : ''" (click)="activeTab('tab3')" *ngIf="isSuperAdmin">
      <span>Signup/Balance/Graph Permission</span>
    </li>
   
    <li [ngClass]="actTab === 'tab6' ? 'active-tab' : ''" (click)="activeTab('tab6')">
      <span>Welcome Email</span>
    </li> -->
  </ul>
  <div class="card">
    <div id="tab1" [hidden]="actTab !== 'tab1'">
      <app-monitor-prd-signup></app-monitor-prd-signup>
    </div>

    <div id="tab3" [hidden]="actTab !== 'tab3'">
      <h3>Enable/Disable Digital SignUp</h3>
      <div class="pl-table m-t m-l">
        <div class="pl-tbody">
          <div class="row">
            <div class="col pl-0 border-b">CALS</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_CALS_DIGITAL_SIGNUP', 'CALS Digital Signup')"
                [onLabel]="'ENABLED'"
                [offLabel]="'DISABLED'"
                name="switch"
                [formControl]="HIDE_CALS_DIGITAL_SIGNUP"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>

          <div class="row">
            <div class="col pl-0 border-b">CALI</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_CALI_DIGITAL_SIGNUP', 'CALI Digital Signup')"
                [onLabel]="'ENABLED'"
                [offLabel]="'DISABLED'"
                name="switch"
                [formControl]="HIDE_CALI_DIGITAL_SIGNUP"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>

          <div class="row">
            <div class="col pl-0 border-b">CALT</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_CALT_DIGITAL_SIGNUP', 'CALT Digital Signup')"
                [onLabel]="'ENABLED'"
                [offLabel]="'DISABLED'"
                name="switch"
                [formControl]="HIDE_CALT_DIGITAL_SIGNUP"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>
        </div>
      </div>

      <h3>Enable/Disable product Balance</h3>
      <div class="pl-table m-t m-l">
        <div class="pl-tbody">
          <div class="row">
            <div class="col pl-0 border-b">CALS</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_CALS_BALANCE', 'CALS Balance')"
                [onLabel]="'BALANCE'"
                [offLabel]="'BALANCE'"
                name="switch"
                [formControl]="HIDE_CALS_BALANCE"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>

          <div class="row">
            <div class="col pl-0 border-b">CALI</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_CALI_BALANCE', 'CALI Balance Display')"
                [onLabel]="'ENABLED'"
                [offLabel]="'DISABLED'"
                name="switch"
                [formControl]="HIDE_CALI_BALANCE"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>

          <div class="row">
            <div class="col pl-0 border-b">CALT</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_CALT_BALANCE', 'CALT Balance Display')"
                [onLabel]="'ENABLED'"
                [offLabel]="'DISABLED'"
                name="switch"
                [formControl]="HIDE_CALT_BALANCE"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>

          <div class="row">
            <div class="col pl-0 border-b">PWM</div>
            <div class="col balance-switch">
              <kendo-switch
                (click)="btnToggle('HIDE_PWM_BALANCE', 'PWM Balance Display')"
                [onLabel]="'ENABLED'"
                [offLabel]="'DISABLED'"
                name="switch"
                [formControl]="HIDE_PWM_BALANCE"
              >
              </kendo-switch>
            </div>
            <div class="col"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="verificationCodes" *ngIf="actTab === 'verificationCodes'">
      <app-verification-codes></app-verification-codes>
    </div>
    <div id="tab6" *ngIf="actTab === 'tab6'">
      <app-welcome-email></app-welcome-email>
    </div>
  </div>
</div>
